const UserCheckIcon = ({ fill = '#6B8282', width = '17', height = '16' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="list/how_to_reg">
        <mask
          id="mask0_8324_10152"
          style={{
            maskType: 'alpha',
          }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="17"
          height="16"
        >
          <rect id="icon" x="0.84375" width="16" height="16" fill="#6B8282" />
        </mask>
        <g mask="url(#mask0_8324_10152)">
          <path
            id="how_to_reg"
            d="M2.17725 13.3333V11.4666C2.17725 11.1 2.27169 10.7555 2.46058 10.4333C2.64947 10.1111 2.91058 9.86662 3.24391 9.69996C3.81058 9.41107 4.44947 9.16663 5.16058 8.96663C5.87169 8.76663 6.65502 8.66663 7.51058 8.66663C7.84391 8.66663 8.16891 8.68329 8.48558 8.71663C8.80225 8.74996 9.11058 8.79996 9.41058 8.86663L8.24391 10.0333C8.12169 10.0111 8.00225 9.99996 7.88558 9.99996H7.51058C6.72169 9.99996 6.01336 10.0944 5.38558 10.2833C4.7578 10.4722 4.24391 10.6777 3.84391 10.9C3.74391 10.9555 3.66336 11.0333 3.60225 11.1333C3.54114 11.2333 3.51058 11.3444 3.51058 11.4666V12H7.67725L9.01058 13.3333H2.17725ZM11.2106 13.6L8.91058 11.3L9.84391 10.3666L11.2106 11.7333L14.5772 8.36663L15.5106 9.29996L11.2106 13.6ZM7.51058 7.99996C6.77725 7.99996 6.14947 7.73885 5.62725 7.21663C5.10502 6.6944 4.84391 6.06663 4.84391 5.33329C4.84391 4.59996 5.10502 3.97218 5.62725 3.44996C6.14947 2.92774 6.77725 2.66663 7.51058 2.66663C8.24391 2.66663 8.87169 2.92774 9.39391 3.44996C9.91614 3.97218 10.1772 4.59996 10.1772 5.33329C10.1772 6.06663 9.91614 6.6944 9.39391 7.21663C8.87169 7.73885 8.24391 7.99996 7.51058 7.99996ZM7.51058 6.66663C7.87725 6.66663 8.19114 6.53607 8.45225 6.27496C8.71336 6.01385 8.84391 5.69996 8.84391 5.33329C8.84391 4.96663 8.71336 4.65274 8.45225 4.39163C8.19114 4.13051 7.87725 3.99996 7.51058 3.99996C7.14391 3.99996 6.83002 4.13051 6.56891 4.39163C6.3078 4.65274 6.17725 4.96663 6.17725 5.33329C6.17725 5.69996 6.3078 6.01385 6.56891 6.27496C6.83002 6.53607 7.14391 6.66663 7.51058 6.66663Z"
            fill={fill}
          />
        </g>
      </g>
    </svg>
  )
}

export default UserCheckIcon
